import {
  API_USIO_PORTAL_ACH_BATCHES,
  API_USIO_PORTAL_ACH_RETURNS,
  API_USIO_PORTAL_BALANCE,
  API_USIO_PORTAL_RISK_REPORT,
  API_USIO_PORTAL_STATEMENT,
  API_USIO_PORTAL_STATUS,
  API_USIO_PORTAL_TRANSACTIONS,
} from 'config'
import Api from 'services/api'

import { PaymentProvider } from './stripe'

/** 'debit' is the collections merchant, 'credit' the disbursements merchant. */
export type UsioMerchantSide = 'debit' | 'credit'

/**
 * Whether USIO is picked anywhere on Rules Configuration > Payment Methods: the default provider,
 * the card or ACH provider of any area, or pinless debit (USIO only). Mirrors the backend's
 * `PaymentGatewayService.isUsioSelected`, which guards the portal's routes.
 */
export const isUsioSelected = (rulesConfig: Record<string, any> = {}) => {
  const picked = (map: any) =>
    !!map && typeof map === 'object' && Object.values(map).some((v) => v === PaymentProvider.usio)
  return (
    rulesConfig.paymentProvider === PaymentProvider.usio ||
    picked(rulesConfig.creditCardPaymentProviders) ||
    picked(rulesConfig.achBankTransferPaymentProviders) ||
    Object.values(rulesConfig.pinlessDebitPaymentMethods || {}).some(Boolean)
  )
}

export const getUsioPortalStatus = () => Api.get(API_USIO_PORTAL_STATUS)

export const getUsioPortalBalance = () => Api.get(API_USIO_PORTAL_BALANCE)

export const getUsioPortalTransactions = (query: {
  dateFrom: string
  dateTo: string
  filter?: string
  merchant?: UsioMerchantSide
}) => Api.get(API_USIO_PORTAL_TRANSACTIONS, query)

export const getUsioPortalAchBatches = (query: { date: string; merchant?: UsioMerchantSide }) =>
  Api.get(API_USIO_PORTAL_ACH_BATCHES, query)

export const getUsioPortalAchReturns = (query: { date: string; merchant?: UsioMerchantSide }) =>
  Api.get(API_USIO_PORTAL_ACH_RETURNS, query)

export const getUsioPortalRiskReport = (query: { merchant?: UsioMerchantSide }) =>
  Api.get(API_USIO_PORTAL_RISK_REPORT, query)

export const getUsioPortalStatement = (query: {
  type: number
  year: number
  month: number
  merchant?: UsioMerchantSide
}): Promise<{ filename: string; contentType: string; base64: string }> => Api.get(API_USIO_PORTAL_STATEMENT, query)
